import React from 'react'
import Filter from './filter'
import Order from './order'
import Editor from './editor'
import Creator from './creator'
import Compiler from './wordcompiler'
import Approval from './approvalwaitinglist'
import AdminApprovalEditor from './aprovereject'
import {useSelectedModule}  from '../redux/navigation'
import PlanManager  from './planmanager'

export default function RenderRoute() {
    const selectedMod = useSelectedModule()
    switch (selectedMod) {
        case 'Approve':
            return <Approval />
        case 'ApprovalEditor':
            return <AdminApprovalEditor />
        case 'Create':
            return <Creator/>
        case 'Editor':
            return <Editor/>
        case 'Find':
            return <Filter/>
        case 'Order':
            return <Order/>
        case 'Preview':
            return <Compiler/>
        case 'Plan':
            return <PlanManager/>
        default:
            return <Order/>
    }
}